import {
  CART_RESERVATION_AIR_PRODUCT_NOT_AVAILABLE,
  ETG_VALIDATION_INVALID_EMAIL_DOMAIN,
  ETG_VALIDATION_INVALID_EMAIL_SYNTAX,
  ETG_VALIDATION_INVALID_PHONE,
  CART_MANAGEMENT_INITIALIZECART_INVALID_PASSENGER_DETAILS_NAME
} from "../constants";

export const isCartValidationError = (errorMessage: string): boolean => {
  if (
    [
      ETG_VALIDATION_INVALID_EMAIL_DOMAIN,
      ETG_VALIDATION_INVALID_PHONE,
      ETG_VALIDATION_INVALID_EMAIL_SYNTAX,
      CART_MANAGEMENT_INITIALIZECART_INVALID_PASSENGER_DETAILS_NAME
    ].includes(errorMessage)
  ) {
    return true;
  }
  return false;
};

export const isPhoneNumberValidationError = (errorMessage: string): boolean => {
  return errorMessage === ETG_VALIDATION_INVALID_PHONE;
};

export const isEmailValidationError = (errorMessage: string): boolean => {
  if (errorMessage === ETG_VALIDATION_INVALID_EMAIL_DOMAIN || errorMessage === ETG_VALIDATION_INVALID_EMAIL_SYNTAX) {
    return true;
  }
  return false;
};

export const isSoldOutFareError = (errorMessage?: string): boolean => {
  return errorMessage === CART_RESERVATION_AIR_PRODUCT_NOT_AVAILABLE;
};

export const isPassengerNameValidationError = (errorMessage: string): boolean => {
  return errorMessage === CART_MANAGEMENT_INITIALIZECART_INVALID_PASSENGER_DETAILS_NAME;
};
